import {Construtor} from './construtor';

export class TipoPontoFisicoParametroGrafico implements Construtor<TipoPontoFisicoParametroGrafico> {
  public idTipoPontoFisicoParametroGrafico: number;
  public idParametroGrafico: number;
  public idTipoPontoFisico: number;
  public alterado: boolean;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof TipoPontoFisicoParametroGrafico) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  copyObject(tipoPontoFisico: TipoPontoFisicoParametroGrafico): void {
    this.idTipoPontoFisicoParametroGrafico = tipoPontoFisico.idTipoPontoFisicoParametroGrafico;
    this.idParametroGrafico = tipoPontoFisico.idParametroGrafico;
    this.idTipoPontoFisico = tipoPontoFisico.idTipoPontoFisico;
  }

  parseFromJson(tipoPontoFisico: any): void {
    this.idTipoPontoFisicoParametroGrafico = tipoPontoFisico.idTipoPontoFisicoParametroGrafico;
    this.idParametroGrafico = tipoPontoFisico.idParametroGrafico;
    this.idTipoPontoFisico = tipoPontoFisico.idTipoPontoFisico;
  }

  modeloCompleto(): boolean {
    return this.idTipoPontoFisico !== undefined;
  }

  getNewInstance(object?: any): TipoPontoFisicoParametroGrafico {
    return new TipoPontoFisicoParametroGrafico(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/tipo-ponto-fisico-parametro-grafico.ts